import { CorpHero } from "../components/home/CorpHero";
import { Marquee } from "../components/site/Marquee";
import { Intro } from "../components/home/Intro";
import { Solutions } from "../components/home/Solutions";
import { PhotoBanner } from "../components/home/PhotoBanner";
import { ModeOfAction } from "../components/home/ModeOfAction";
import { ScienceBento } from "../components/home/ScienceBento";
import { SpeciesSelector } from "../components/home/SpeciesSelector";
import { Company } from "../components/home/Company";
import { Brochures, EnquiryBlock } from "../components/home/Closing";
import { LatestNews } from "../components/news/LatestNews";
import { useTitle } from "../lib/useTitle";

export default function Home() {
  useTitle("Gait Naurish Ltd. — Feed Palatability, Aqua & Poultry Performance Solutions");
  return (
    <main data-testid="home-page">
      <CorpHero />
      <Intro />
      <Solutions />
      <Marquee />
      <ModeOfAction />
      <ScienceBento />
      <SpeciesSelector />
      <PhotoBanner />
      <Company />
      <LatestNews />
      <Brochures />
      <EnquiryBlock defaultProduct="PALATIVA" />
    </main>
  );
}
